import DeleteAiDocModal from './DeleteAiDocModal'

export default DeleteAiDocModal
